import api from "../api/axiosConfig";

const adminReportService = {
  get: (params) => api.get("/admin/reports", { params }),
};

export default adminReportService;
